export const imageBaseURL = 'https://cdn-image.staticsfly.com';
export const monthsList = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const DC_SERVICE_API_KEYS = {
    PROD: 'RpZyUyLnS6YP1UVEccqGlU03FJHAujXF',
    NON_PROD: '06h8A9QTVBXAfEqYMCItB7nM2n2Q0r30'
};
